import { ROLES } from '@/constants/roles';

export const uiGiftedChildrenMain = {
  path: '/gifted-children-main',
  name: 'ui-gifted-children-main',
  component: () => import('./views/gifted-children-main.vue'),
  meta: {
    title: 'Одарённые дети',
    layout: 'ui-design',
    accessList: [ROLES.operator, ROLES.department],
  },
};

export const uiGiftedChildrenRegistry = {
  path: '/gifted-children-registry',
  name: 'ui-gifted-children-registry',
  component: () => import('./views/gifted-children.vue'),
  meta: {
    layout: 'ui-design',
    title: 'Реестр одаренных детей',
    back: true,
    accessList: [ROLES.operator, ROLES.department],
    instruction: {
      id: { [ROLES.operator]: 31, '*': 43 },
      name: 'Реестр одаренных детей',
    },
  },
};

export default [
  uiGiftedChildrenMain,
  uiGiftedChildrenRegistry,
  {
    path: '/rating-events',
    name: 'ui-rating-events',
    component: () => import('./views/rating-events.vue'),
    meta: {
      layout: 'ui-design',
      title: 'Реестр значимых мероприятий',
      back: true,
      accessList: [ROLES.operator],
    },
  },
];
